import Swiper from "swiper";
import { Thumbs } from "swiper/modules";

/**
 * 
 * @param {輪播圖頁數資料} data 
 * @returns 
 */
function thumbsSwiperInit(data) {
  const swiperThumbsBottom = new Swiper(".swiper__thumbsBottom", {
    // loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiperThumbsTop = new Swiper(".swiper__thumbsTop", {
    modules: [Thumbs],
    // loop: true,
    spaceBetween: 12,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperThumbsBottom,
    },
    on: {
      slideChangeTransitionStart: function (e) {
        data.index = e.activeIndex;
      },
    },
  });

  return swiperThumbsTop;
}

/**
 * 輪播按鈕監聽
 * @param {輪播圖頁數資料} data 
 */
function thumbsSwiperBtnListener(data) {
  const swiperBtnPrev = document.querySelector(`[data-id="swiper-btn-prev"]`);
  const swiperBtnNext = document.querySelector(`[data-id="swiper-btn-next"]`);

  swiperBtnPrev.addEventListener("click", (e) => {
    e.stopPropagation();
    data.index--;
  });

  swiperBtnNext.addEventListener("click", (e) => {
    e.stopPropagation();
    data.index++;
  });
}

export { thumbsSwiperInit ,thumbsSwiperBtnListener};
